export default __webpack_public_path__ + "static/media/GettyImages-640905870_BW.ebae10ef.jpg";